import { useCallback, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../common/hooks'
import { sessionActions } from '../../store/slices/session'

import {
  StyledContainer,
  StyledCloseButton,
  StyledCloseIcon,
  StyledModal,
} from './styles/SignupModal.style'
import PreSignupContent from './PreSignupContent'
import { PreSignupForm } from './PreSignupForm'
import { PreSignupSuccessContent } from './PreSignupSuccessContent'

export const PreSignupModal = (): JSX.Element => {
  const dispatch = useAppDispatch()
  const open = useAppSelector((s) => s.session.showSignupModal)
  const showWidget = useAppSelector((s) => s.session.showWidget)
  const [showSuccess, setShowSuccess] = useState(false)
  const isWidgetVisible = showWidget ?? false

  const hide = useCallback(() => {
    dispatch(sessionActions.hideSignupModal())
  }, [dispatch])

  const handleOpenWidget = useCallback(() => {
    dispatch(sessionActions.setSignupWidget(true))
  }, [])

  const handleWidgetSubmit = useCallback(() => {
    setShowSuccess(true)
    setTimeout(() => {
      dispatch(sessionActions.setUtmMedium(undefined))
      dispatch(sessionActions.hideSignupModal())
    }, 7000)
  }, [dispatch])

  const content =
    showWidget ?? false ? (
      showSuccess ? (
        <div style={{ width: '100%', height: '100%' }}>
          <PreSignupSuccessContent hide={hide} />
        </div>
      ) : (
        <div style={{ width: '100%', height: 520 }}>
          <PreSignupForm onSubmitSuccess={handleWidgetSubmit} />
        </div>
      )
    ) : (
      <PreSignupContent onPrimaryClick={handleOpenWidget} isModalOpen={!!open} hide={hide} />
    )

  return (
    <StyledModal
      open={!!open}
      onClose={(_, reason) => {
        if (reason !== 'backdropClick') hide()
      }}
      showWidget={isWidgetVisible}
      disableEscapeKeyDown
    >
      <StyledContainer showWidget={isWidgetVisible} showSuccess={showSuccess}>
        {isWidgetVisible && !showSuccess && (
          <StyledCloseButton onClick={hide}>
            <StyledCloseIcon />
          </StyledCloseButton>
        )}
        {content}
      </StyledContainer>
    </StyledModal>
  )
}

export default PreSignupModal
